import createTanstackTableDataStore from '@/ui/TanstackTable/createTanstackTableDataStore';

import { AdminUserListItemType } from './columns';

const useAdminUserTableStore = createTanstackTableDataStore<AdminUserListItemType>({
  storeName: 'admin-user-table-store',
  defaultColumnSizing: {
    email: 174,
    clientId: 194,
    createdAt: 127,
  },
  defaultColumnVisibility: {
    id: false,
  },
});

export default useAdminUserTableStore;
